import { render } from "./UpdateStore.vue?vue&type=template&id=63501c40"
import script from "./UpdateStore.vue?vue&type=script&lang=js"
export * from "./UpdateStore.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__